export const generateData = (data, slidesToShow) => {
    let discardArray = []
    const length = data.length
    const newRecord = data.concat(data.slice(0, slidesToShow - 1))
    newRecord.map((_, key) => discardArray.push(key))
    return {
      data: newRecord,
      discardIndexes: discardArray.slice(length),
    }
}
